import React, { Fragment } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';
import Summary from 'routes/checkoutPage/components/travelSummary/components/summarySection/SummarySection';
import UpgradeTypesComponent from './components/upgradeTypes/UpgradeTypesComponent';

function FlightsExtrasSummaryComponent({ summaryKey, leaveDirection, returnDirection, bothDirections }) {
  const title = <FormattedMessage id={'extras.label'} description={'Extras'} defaultMessage={'Extras'} />;
  return (
    <Summary summaryKey={summaryKey} title={title}>
      <Root>
        {leaveDirection.length > 0 && (
          <Fragment>
            <Heading>
              <FormattedMessage id={'leave.label'} description={'Leave'} defaultMessage={'Leave'} />
              {leaveDirection[0].departureAirport && (
                <span>
                  ({leaveDirection[0].departureAirport} - {leaveDirection[0].destinationAirport})
                </span>
              )}
            </Heading>
            {leaveDirection.map(({ type, price, description }, index) => (
              <UpgradeTypesComponent
                key={`leave-direction-${index}`}
                type={type}
                price={price}
                description={description}
              />
            ))}
          </Fragment>
        )}
        {returnDirection.length > 0 && (
          <Fragment>
            <Heading>
              <FormattedMessage id={'return.label'} description={'Return'} defaultMessage={'Return'} />
              {returnDirection[0].departureAirport && (
                <span>
                  ({returnDirection[0].departureAirport} - {returnDirection[0].destinationAirport})
                </span>
              )}
            </Heading>
            {returnDirection.map(({ type, price, description }, index) => (
              <UpgradeTypesComponent
                key={`return-direction-${index}`}
                type={type}
                price={price}
                description={description}
              />
            ))}
          </Fragment>
        )}
        {bothDirections.length > 0 &&
          bothDirections.map(({ type, price, description }, index) => (
            <UpgradeTypesComponent
              key={`both-directions-${index}`}
              type={type}
              price={price}
              description={description}
            />
          ))}
      </Root>
    </Summary>
  );
}

export default FlightsExtrasSummaryComponent;

const Root = styled.div`
  > * {
    margin-bottom: 20px;
  }
`;

const Heading = styled.div`
  font-size: 1.2em;
  color: ${({ theme }) => theme.colors.text.default};
  font-weight: bold;

  span {
    margin-left: 5px;
  }
`;
